module.exports = __webpack_public_path__ + "img/badge_services_silver.7bc80a87.png";